//containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '@/containers-m/Navigation';
import { BackgroundImageSection } from '@/containers-m/BackgroundImageSection';

//data
import { contactOptions } from '@/vendor/HubspotFormIntegration';

// context containers
import { Hero, Office, NeedAssistance, GetInTouch } from './containers';

//styles
import { PageWrapper, ContactGlobalStyle } from './Contact.styles';

const bgSection = {
  title: 'Become a Loadie!',
  description: (
    <>
      We’re always looking to connect with world-class thinkers, strategists,
      doers, and leaders. Check out our open positions below.
    </>
  ),
  image: {
    xxlarge: 'images/careers/become/become-loadie-xxlg.jpg',
    large: 'images/careers/become/become-loadie-lg.jpg',
    medium: 'images/careers/become/become-loadie-md.jpg',
    small: 'images/careers/become/become-loadie-sm.jpg',
  },
  CTA: {
    label: 'Learn more',
    link: 'https://jobs.lever.co/loadsmart/',
    external: true,
  },
  biggerBg: false,
};

const form_content = {
  title: <>Get In Touch</>,
  subtitle: (
    <>
      Loadsmart is your next-gen logistics solutions provider that supports
      your team from the time an order is placed to the final invoice of
      shipment. Drop us a line and we’ll be in touch with you soon.
    </>
  ),
};

const Contact = () => {
  return (
    <PageWrapper>
      <ContactGlobalStyle />
      <Navigation theme="dark" />
      <Hero />
      <Office />
      <NeedAssistance />
      <div id="contact-form">
        <GetInTouch
          title={form_content.title}
          subtitle={form_content.subtitle}
          {...contactOptions}
          disclaimer={true}
        />
      </div>
      <BackgroundImageSection content={bgSection} />
      <Footer />
    </PageWrapper>
  );
};

export default Contact;
export { Contact };
